<template>
    <div class="card">
        <!-- Title -->
        <div class="card-header">Sơ đồ chỉ đường</div>
        <div class="flex flex-column align-items-center">
            <div class="location-container flex flex-column mb-5 flex-1 justify-content-center">
                <div class="w-full text-xl time-spot flex justify-content-center align-items-center mb-2">
                    <div>
                        <div class="location-name">Mairie Noisy Le Grand</div>
                        <div class="text-sm text-gray-600 mb-3">
                            Pl. de la Libération, 93160 Noisy-le-Grand
                        </div>
                    </div>
                </div>
                <div class="public-transport">
                    <div class="flex justify-content-start mb-2 align-items-center">
                        <img src="@/assets/images/RER.svg" alt="RER" class="mr-2" style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/RER_A.svg" alt="RER A" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <p class="font-medium text-left"><strong>Noisy-le-Grand Mont d'Est</strong></p>
                    </div>
                    <div class="flex justify-content-start mb-2 align-items-center">
                        <img src="@/assets/images/Paris_Bus_icon.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_303.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_310.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_320.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <p class="font-medium text-left"><strong>Mairie de Noisy-le-Grand</strong></p>
                    </div>
                    <div class="flex justify-content-start mb-2 align-items-center">
                        <img src="@/assets/images/Paris_Bus_icon.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_220.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <p class="font-medium text-left"><strong>Mairie de Noisy-le-Grand - Jean Vaquier</strong></p>
                    </div>
                </div>
                <div class="automobile">
                    <div class="flex justify-content-start mb-2">
                        <i class="pi pi-car mr-2 text-4xl"></i>
                        <div>
                            <p class="font-medium text-left">
                                <b>Bằng ô tô</b>, bạn có thể đỗ xe:
                            </p>
                            <ul class="text-left list-disc m-0 mb-3">
                                <li>
                                    Trên phố xung quanh khu vực Mairie Noisy Le Grand : miễn phí.
                                </li>
                                <li>
                                    Bãi đỗ đối diện bể bơi <strong>Centre Aquatique Les Nymphéas</strong> : trả phí.
                                </li>

                            </ul>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1312.7384134678257!2d2.5538600175350097!3d48.849117182107726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e60e03c73e6003%3A0xe1256a693cb6e152!2sParking%20Indigo%20Noisy-Le-Grand%20Parc%20Du%20Centre!5e0!3m2!1sen!2sfr!4v1749432887414!5m2!1sen!2sfr"
                                class="w-full" style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="location-container flex flex-column flex-1 justify-content-center">
                <div class="w-full text-xl time-spot flex justify-content-center align-items-center mb-2">
                    <div>
                        <div class="location-name">Paris Dream Villa</div>
                        <div class="text-sm text-gray-600 mb-3">
                            36 Rue Karl Liebknecht, 94800 Villejuif
                        </div>
                    </div>
                </div>
                <div class="public-transport">
                    <div class="flex justify-content-start mb-2 align-items-center">
                        <img src="@/assets/images/metro.svg" alt="Metro" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/metro_7.svg" alt="Ligne 7" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <p class="font-medium text-left"><strong>Villejuif - Paul Vaillant-Couturier</strong></p>
                    </div>
                    <div class="flex justify-content-start mb-2 align-items-center">
                        <img src="@/assets/images/Paris_Bus_icon.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_131.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_162.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <img src="@/assets/images/bus_185.svg" alt="bus" class="mr-2"
                            style="width: 2rem; height: 2rem;">
                        <p class="font-medium text-left"><strong>Villejuif - Paul Vaillant-Couturier</strong></p>
                    </div>
                </div>
                <div class="automobile">
                    <div class="flex justify-content-start mb-2">
                        <i class="pi pi-car mr-2 text-4xl"></i>
                        <div>
                            <p class="text-left mb-3"><b>Bằng ô tô:</b> Có thể đỗ xe trước nhà hoặc trên các tuyến phố
                                xung quanh.</p>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d657.0804999858859!2d2.3708160264086175!3d48.79483278065574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e673b33ba07f3b%3A0xf23a549a3a52feb9!2sParis%20Dream%20Villa!5e0!3m2!1sen!2sfr!4v1749433208474!5m2!1sen!2sfr"
                                class="w-full" style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="location-container flex flex 1">
                <div class="w-20 text-right text-xl pr-4 time-spot flex justify-content-center align-items-center flex-column">
                    Tiệc <span>🥂</span>
                </div>
                <div class="separator h-full"></div>
                <div class="separator h-full"></div>
                <div class="location flex align-items-center justify-content-center pl-4 flex-1">
                    <p class="font-medium"><a href="https://maps.app.goo.gl/3rChiuvg5k5jviGx6" target="_blank">📍 Nâng
                            ly nào 🍷: Paris Dream Villa</a></p>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>

export default {
    name: 'AccessComponent',
    props: {
        location: {
            type: Object,
            default: () => ({
                name: "Mairie Noisy Le Grand",
                // TODO: add transportation details
                // publicTransport: [
                //     {
                //         name: "Đi tàu RER A",
                //         details: [
                //             {
                //         type: "RER",
                //         line: "A",
                //         station: "Noisy-le-Grand Mont d'Est"
                //     },
                //     {
                //         type: "Bus",
                //         line: "310",
                //         station: "Mairie Noisy Le Grand"
                //     }
                //         ]
                //     }
                // ],
            })
        }
    }
};
</script>

<style scoped>
p {
    margin: 0;
}

/* Optional: custom styling can go here */
.time-spot {
    font-family: "BeautiqueDisplay", cursive;
    width: 86px;
}

.location-name {
    font-size: 1.2rem
}

.separator {
    width: 2px;
    height: 100%;
    background-color: #b23a48;
    margin-right: 1.5px;
}

.location-container {
    height: 172px;
    width: 60%;
}

.location {
    font-family: "Xuong", cursive;
    font-size: 1.8rem;

    a {
        color: #b23a48;
    }
}

@media screen and (max-width: 768px) {
    .location-container {
        width: 100%;
    }
}
</style>
